module.exports = require('./helpers/bundle-url').getBundleURL('cQKSD') + "ring.4766a2b7.png";